// src/hooks/usePageContent.js
import { useEffect, useState } from 'react';
import { getCurrentConfig } from '../services/appService';

const useGetDefaultConfig = () => {
  const [data, setData] = useState(null);
  const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:3010/';

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await fetch(baseURL + "api/User/GetCompanySetting"); // adjust URL to your API
        const json = await res.json();
        setData(json);
      } catch (err) {
        console.error("Failed to fetch config:", err);
      }
    };

    fetchConfig();
  }, []);

  return { data };
};

// const useGetDefaultConfig = () => {
//     const [status, setStatus] = useState('idle'); // idle | loading | done | error
//     const [error, setError] = useState('');
//     const [data, setData] = useState({});

//     const fetchConfigGet = async () => {
//         setStatus('loading');
//         setError('');

//         try {
//             const response = await getCurrentConfig();

//             if (response?.status !== 'Error') {
//                 setStatus('done');
//                 setData(response.data ?? response); // depending on API shape
//             } else {
//                 setStatus('error');
//                 setError(response?.message || 'Something went wrong');
//             }
//         } catch (err) {
//             setStatus('error');
//             setError(err?.message || 'Something went wrong');
//         }
//     };

//     const resetStatus = () => {
//         setStatus('idle');
//         setError('');
//     };

//     return {
//         fetchConfigGet,
//         data,
//         status,
//         error,
//         resetStatus
//     };
// };

export default useGetDefaultConfig;
